import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import React, { useEffect, useRef, useState } from "react";
import { tt } from "../../utils/i18n/i18n";

interface ControlledManagedAccountDropdownProps {
  accounts: ManagedAccount[];
  selectedAccount: ManagedAccount | undefined;
  selectedAccountIndex: number | undefined;
  onAccountChange: (account: ManagedAccount, index: number) => void;
  placeholder?: string;
}

export const ControlledManagedAccountDropdown: React.FC<
  ControlledManagedAccountDropdownProps
> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleAccountChange = (account: ManagedAccount, index: number) => {
    props.onAccountChange(account, index);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "relative",
        display: "inline-block",
        width: "100%",
        zIndex: 2000
      }}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          padding: "8px 12px",
          border: "1px solid #d9d9d9",
          borderRadius: "4px",
          backgroundColor: "white",
          opacity: 1,
          zIndex: 2000
        }}
      >
        <span>{props?.selectedAccount?.placeName}</span>
        <span
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease"
          }}
        >
          ▼
        </span>
      </div>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "4px",
            background: "white",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            width: "100%",
            zIndex: 1000,
            maxHeight: "300px",
            overflowY: "auto"
          }}
        >
          {props.accounts.map((account, idx) => {
            if (account.businessUser?.hide) {
              return null;
            }
            return (
              <div
                key={account.email}
                onClick={() => handleAccountChange(account, idx)}
                className="p-4 cursor-pointer"
                style={{
                  borderBottom:
                    props.accounts.indexOf(account) < props.accounts.length - 1
                      ? "1px solid #f0f0f0"
                      : "none",
                  backgroundColor:
                    props.selectedAccount?.email === account.email
                      ? "#f5f5f5"
                      : "white",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  if (props.selectedAccount?.email !== account.email) {
                    e.currentTarget.style.backgroundColor = "#fafafa";
                  }
                }}
                onMouseLeave={(e) => {
                  if (props.selectedAccount?.email !== account.email) {
                    e.currentTarget.style.backgroundColor = "white";
                  }
                }}
              >
                <div className="font-weight-bold">
                  {account.placeName ||
                    `${tt("jp_default_place_name")} ${idx + 1}`}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
